<template>

    <fragment>

        <div v-if="dataStore.showProjectStatePopUp" id="project-states-popup" class="general-popup">

            <div class="wrapper">

                <span class="close-popup" v-on:click.prevent="dataStore.showProjectStatePopUp=false"><i class="fas fa-times"></i></span>

                <div class="content">

                    <h2>{{ language.dialogue_phases_title }}</h2>

                    <div class="form-group" v-for="(val, index) in dataStore.project.projectState" :key="index">

                        <label for="exampleInputEmail1">{{ language.dialogue_phases_phase.replacePlaceholders({ row : index + 1 }) }}</label>

                        <div class="state split-50">
                            <input type="text" class="form-control" v-model="dataStore.project.projectState[index].name" :placeholder="language.dialogue_phases_placeholder">
                            <input type="text" class="form-control" v-model="dataStore.project.projectState[index].link" :placeholder="language.dialogue_phases_placeholder_link">
                        </div>

                    </div>

                    <button type="submit" v-on:click.prevent="closeWindow" class="btn btn-primary">{{ language.save }}</button>

                </div>

            </div>

        </div>

        <div class="form-group project-states">
            <div class="form-group-wrap">
                <div class="wrapper-for-states">
                    <button class="btn btn-primary" v-on:click.prevent="dataStore.showProjectStatePopUp=true">{{ language.add }}</button>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label for="current-project-states">{{ language.dialogue_phases_current }}</label>
            <select v-model="dataStore.project.currentProjectState" class="form-control" id="current-project-states">
                <option value="">{{ language.dialogue_phases_select }}</option>
                <fragment v-if="dataStore.project.projectState && dataStore.project.projectState.length">
                    <option v-for="(val, typeIndex) in dataStore.project.projectState.filter(item => item.name)" :selected="val.id == dataStore.project.currentProjectState ? 'selected' : ''" :key="`type-${typeIndex}`" :value="val.name ? val.name : val">{{ val.name ? val.name : val }}</option>
                </fragment>
            </select>
        </div>

    </fragment>
</template>

<script>

import dataStore from '../../store'

import globalFunctions from '../../globalFunctions'

import { Fragment } from 'vue-fragment'

export default {

    data() {
        return {
            dataStore,
            globalFunctions,

        }
    },

    inject: [ 'language' ],

    components : {
        Fragment
    },

    methods : {
        closeWindow: function() {
            this.dataStore.showProjectStatePopUp = false
        },

        closeMe: function(e) {
            if(e.target.classList.contains('general-popup')) {
                this.closeWindow();
            }
        }
    }

};
</script>
